// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import styled from 'styled-components';

import { baseSpacing, baseStyles } from '../Base';
import { LabelProps } from '.';
import { StyledCheckbox } from '../Checkbox/Styled';

export const StyledLabel: any = styled.label<LabelProps>`
  ${(props) =>
    props.normalText
      ? `
      color: ${props.theme.inputs.fontColor};
      font-size: ${props.theme.fontSizes.text.fontSize};
      display: inline-flex;
      align-items: center;
      cursor: pointer;

      ${StyledCheckbox} {
        margin-right: 0.5rem;
      }
    `
      : `
      color: ${props.theme.inputs.labelColor};
      font-size: ${props.theme.fontSizes.label.fontSize};
      font-weight: ${props.theme.fontSizes.label.fontWeight};
      line-height: ${props.theme.fontSizes.label.lineHeight};
      display: inline-block;
  `}
  vertical-align: bottom;

  ${baseSpacing}
  ${baseStyles}
`;
